<div class="container">
  <div class="text-center">
    <strong class="mainHeading">Zones</strong>
  </div>
  <div class="toolbar d-flex align-items-center gap-2">
    <button
      class="btn btn-primary"
      (click)="exportToExcel()"
      ngbTooltip="Export to excel"
    >
      <span><i class="bi bi-box-arrow-up me-2"></i></span>Export
    </button>
    <button
      class="btn btn-primary"
      (click)="clearGrid(searchInput)"
      ngbTooltip="Clear filter"
    >
      <span> <i class="bi bi-x-circle me-2"></i></span>Clear Filter
    </button>
    <button
      class="btn btn-primary btn-sm"
      (click)="exportToPDF()"
      ngbTooltip="Print"
    >
      <span><i class="bi bi-printer me-2"></i></span>Print
    </button>
    <input
    #searchInput
      type="text"
      class="form-control w-auto"
      placeholder="Search"
      (input)="search($event)"
    />
  </div>
 
  <div class="card shadow-lg p-4">
    <table class="table table-striped table-bordered text-center">
      <thead class="table-light">
        <tr>
          <!-- <th class="text-center">City ID</th> -->
            <th>S.No</th>
          <th class="text-center">
            City Name
            <i
              class="bi bi-funnel ms-2"
              id="cityFilterDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            ></i>
            <ul class="dropdown-menu" aria-labelledby="cityFilterDropdown">
              <li>
                <a class="dropdown-item" (click)="applyCityFilter('')">All</a>
              </li>
              <li *ngFor="let city of selectCityData">
                <a
                  class="dropdown-item"
                  (click)="applyCityFilter(city.cityName)"
                >
                  {{ city.cityName }}
                </a>
              </li>
            </ul>
          </th>
          <!-- <th class="text-center">Zone Id</th> -->
          <th class="text-center">
            Zone Name
            <i
              class="bi bi-funnel ms-2"
              id="zoneFilterDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            ></i>
            <ul class="dropdown-menu" aria-labelledby="zoneFilterDropdown">
              <li>
                <a class="dropdown-item" (click)="applyZoneFilter('')">All</a>
              </li>
              <li *ngFor="let zone of zoneNames">
                <a class="dropdown-item" (click)="applyZoneFilter(zone)">
                  {{ zone }}
                </a>
              </li>
            </ul>
          </th>
          <th class="text-center">Date Created</th>
          <th class="text-center">
            <div class="d-flex justify-content-center align-items-center">
              <span
                >Is Active
                <i
                  class="bi bi-funnel ms-2"
                  id="isActiveDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                ></i>
                <ul class="dropdown-menu" aria-labelledby="isActiveDropdown">
                  <li>
                    <a class="dropdown-item" (click)="toggleStatusFilter('')"
                      >All</a
                    >
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      (click)="toggleStatusFilter('Active')"
                      >Active</a
                    >
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      (click)="toggleStatusFilter('Inactive')"
                      >Inactive</a
                    >
                  </li>
                </ul>
              </span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let city of pagedData; let i = index">
          <td class="text-center">{{ getSerialNumber(i) }}</td>
          <td>{{ city.cityName }}</td>
          <td>{{ city.zoneName }}</td>
          <td>{{ city.createdDate | date : "dd MMM yyyy" }}</td>
          <td class="status-cell">
            <p
              [ngClass]="{
                approved: city.zoneStatus === true
              }"
              class="status-paragraph"
            >
              <span
                class="status-dot"
                [ngClass]="{
                  'dot-green': city.zoneStatus === true,
                  'dot-red': city.zoneStatus !== true
                }"
              ></span>
              {{ getStatus(city.zoneStatus) }}
            </p>
          </td>
        </tr>
        <tr *ngIf="pagedData?.length === 0">
          <td colspan="5" class="text-center">No Data Found</td>
        </tr>
        <tr *ngIf="pagedData?.length === 0 && !cityFilterApplied">
          <td colspan="6" class="text-center">{{ noDataMessage }}</td>
        </tr>
 
        <!-- Show "No zone available for the selected city" message only if city filter is applied -->
        <tr *ngIf="pagedData?.length === 0 && cityFilterApplied">
          <td colspan="6" class="text-center">{{ noDataMessage }}</td>
        </tr>
      </tbody>
    </table>
 
    <!-- Pagination -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <div class="d-flex align-items-center me-3 mb-2">
        <label class="me-2 mb-0">Show</label>
        <select
          class="form-select"
          [(ngModel)]="pageSize"
          (change)="onPageSizeChange()"
        >
          <option *ngFor="let size of pageSizeOptions" [value]="size">
            {{ size }}
          </option>
        </select>
        <label class="ms-2 mb-0">entries</label>
      </div>
   
      <!-- Pagination Centered -->
      <div class="d-flex justify-content-center flex-grow-1">
        <ngb-pagination
          *ngIf="cityData?.length > 0"
          [(page)]="page"
          [pageSize]="pageSize"
          [collectionSize]="cityData?.length"
          (pageChange)="onPageChange($event)"
          [boundaryLinks]="true"
        >
        </ngb-pagination>
      </div>
   
      <!-- Entries Count Message Aligned to the End -->
      <div *ngIf="cityData?.length > 0" class="text-muted mb-3 ms-3">
        <strong>
          Showing {{ (page - 1) * pageSize + 1 }} to
          {{
            page * pageSize > cityData?.length
              ? cityData?.length
              : page * pageSize
          }}
          of {{ cityData?.length }} entries
        </strong>
      </div>
    </div>
   
  </div>
</div>
 
<!-- Create Zone Modal -->
<ng-template #createZoneModal let-modal>
  <div class="modal-header custom-modal-header">
    <h5 class="modal-title mt-2">Create Zone</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss()"
    >
      X
    </button>
  </div>
  <form [formGroup]="createZoneForm">
    <div class="modal-body">
      <div class="form-group">
        <label for="citySelect">Select City</label>
        <select
          class="form-select mt-1"
          id="citySelect"
          formControlName="cityName"
          [ngClass]="{
            'invalid-field':
              createZoneForm.controls['cityName'].invalid &&
              createZoneForm.controls['cityName'].touched
          }"
        >
          <option *ngFor="let city of selectCityData" [ngValue]="city">
            {{ city.cityName }} - {{ city.id }}
          </option>
        </select>
      </div>
      <div class="form-group mt-2">
        <label for="zoneName">Zone Name</label>
        <input
          type="text"
          class="form-control mt-1"
          id="zoneName"
          formControlName="zoneName"
          placeholder="Enter Zone Name"
          [ngClass]="{
            'invalid-field':
              createZoneForm.controls['zoneName'].invalid &&
              createZoneForm.controls['zoneName'].touched
          }"
        />
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="addNewZone(modal)">
        Submit
      </button>
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
        Cancel
      </button>
    </div>
  </form>
</ng-template>
 
<!-- Change Status Modal -->
<ng-template #confirmModal let-modal>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Change Zone Status</h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="modal.dismiss()"
        >
          X
        </button>
      </div>
      <div class="modal-body">
        <p>
          Do you want to change the status of the Zone to
          <strong>
            {{
              currentCityForStatusChange.zoneStatus ? "Inactive" : "Active"
            }} </strong
          >?
        </p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="modal.dismiss()">
          Cancel
        </button>
        <button class="btn btn-primary" (click)="changeZoneStatus(modal)">
          Confirm
        </button>
      </div>
    </div>
  </div>
</ng-template>